(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1241],{

/***/ 70837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact_us_form; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 7 modules
var Select = __webpack_require__(24951);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts
var api = __webpack_require__(83023);
// EXTERNAL MODULE: ./api/SiteId.ts
var SiteId = __webpack_require__(8163);
// EXTERNAL MODULE: ./common/NextLink.tsx
var NextLink = __webpack_require__(44074);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(75625);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./common/formik/MuiCheckbox.tsx





var _excluded = ["name", "label", "required", "inputRef", "onChange", "children", "error", "helperText", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MuiCheckbox__StyledContainer",
  componentId: "sc-gdtvkt-0"
})(["display:flex;flex-direction:column;", ";.MuiFormControlLabel-root{display:flex;align-items:center;margin-right:0px;margin-left:0px;}.MuiFormControlLabel-label{text-align:start !important;font-size:12px;line-height:1.2;}"], function (p) {
  return p.$isEnglish ? "margin-left: -7px" : "margin-right: -7px";
}); // const StyledCheckboxWithLabel = styled(CheckboxWithLabel)<{
//   $english: boolean
// }>`
//   padding: 0;
//   ${(p) => (p.$english ? `margin-right: 7px` : `margin-left: 7px`)}
// `

var StyledError = (0,styled_components_browser_esm/* default */.ZP)(FormHelperText/* default */.Z).withConfig({
  displayName: "MuiCheckbox__StyledError",
  componentId: "sc-gdtvkt-1"
})(["bottom:-0.5em;right:1px;"]);

var MuiCheckbox = function MuiCheckbox(_ref) {
  var name = _ref.name,
      label = _ref.label,
      required = _ref.required,
      inputRef = _ref.inputRef,
      _onChange = _ref.onChange,
      children = _ref.children,
      error = _ref.error,
      helperText = _ref.helperText,
      value = _ref.value,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
    $isEnglish: locale === "en",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
      control: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, _objectSpread({
        onChange: function onChange(e) {
          return _onChange(e, name);
        },
        name: name,
        ref: inputRef,
        value: value
      }, props)),
      label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [label, children]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledError, {
      id: "".concat(name, "-helper-text"),
      children: helperText
    }), error && required && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledError, {
      id: "".concat(name, "-helper-text"),
      children: helperText
    })]
  });
};

/* harmony default export */ var formik_MuiCheckbox = (MuiCheckbox);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
;// CONCATENATED MODULE: ./common/formik/MuiInput.tsx



var MuiInput_excluded = ["name", "label", "type", "required", "autoFocus", "variant", "onChange", "inputRef"];

function MuiInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MuiInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MuiInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MuiInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var Styled = {
  Field: (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z).withConfig({
    displayName: "MuiInput__Field",
    componentId: "sc-1u0n6dn-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:15px;}.MuiFormHelperText-root.Mui-error{", "}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  })
};

var MuiInput = function MuiInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      autoFocus = _ref.autoFocus,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "standard" : _ref$variant,
      _onChange = _ref.onChange,
      inputRef = _ref.inputRef,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, MuiInput_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Styled.Field, MuiInput_objectSpread({
    id: name,
    name: name,
    helperText: props.helperText,
    error: props.error,
    label: label,
    fullWidth: true,
    type: type,
    required: required,
    autoFocus: autoFocus,
    variant: variant,
    ref: inputRef,
    onChange: function onChange(e) {
      _onChange(e, name);
    }
  }, props));
};

/* harmony default export */ var formik_MuiInput = (MuiInput);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
// EXTERNAL MODULE: ./src/routes/mainRoutes.ts
var mainRoutes = __webpack_require__(54385);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./common/formik/FormikSchema.ts

var max = {
  fullname: [50, "ניתן להזין עד 50 תווים"]
};
var required = {
  "default": "שדה זה הינו שדה חובה",
  firstName: "יש להזין שם פרטי",
  lastName: "יש להזין שם משפחה",
  phoneNumber: "יש להזין מספר טלפון",
  licenseNumber: "יש להזין לוחית רישוי",
  licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
  modelId: "בחר דגם",
  area: "בחר איזור",
  skuOrName: "נא הכנס טקסט חופשי או מספר פריט"
};
var regex = {
  numbers: /^[0-9]*$/,
  singleName: /^([a-zA-Zא-ת'"\\.\-,\s]+)$/,
  fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
  name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  licenseNumber: /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
  licenceOrChassis: /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/
};
var invalid = {
  numbers: "יש להזין ספרות בלבד",
  fullName: "שם מלא לא תקין",
  name: "יש להזין אותיות בעברית / אנגלית בלבד",
  email: "כתובת המייל אינה תקינה",
  phoneNumber: "מספר הטלפון אינו תקין",
  licenseNumber: "נא להזין מספר בעל 7-8 תווים המורכב מספרות בלבד",
  licenceOrChassis: "מספר רישוי או שילדה לא תקין"
};
var schemaCommon = {
  phoneNumber: es/* string */.Z_().matches(regex.phoneNumber, "יש להזין מספר נייד תקין").length(10, "יש להזין מספר נייד תקין").required("יש להזין מספר נייד תקין").max(10, "יש להזין עד 10 ספרות בלבד"),
  firstName: es/* string */.Z_().matches(regex.singleName, "יש להזין אותיות בלבד").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(40, "יש להזין עד 40 תווים בלבד").required(required["default"]),
  lastName: es/* string */.Z_().matches(regex.singleName, "יש להזין אותיות בלבד").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(80, "יש להזין עד 80 תווים בלבד").required(required["default"]),
  fullName: es/* string */.Z_().matches(regex.fullName, "יש להזין אותיות בלבד").required(required["default"]),
  email: es/* string */.Z_().email("יש להזין כתובת מייל תקינה").max(80, "יש להזין עד 80 תווים בלבד").required(required["default"]),
  city: es/* string */.Z_(),
  street: es/* string */.Z_(),
  apartmentNumber: es/* string */.Z_().matches(regex.numbers, invalid.numbers),
  floorNumber: es/* string */.Z_().matches(regex.numbers, invalid.numbers),
  entranceNumber: es/* string */.Z_().matches(regex.numbers, invalid.numbers),
  comments: es/* string */.Z_()
};
;// CONCATENATED MODULE: ./components/contact-us/SchemaSignUp.ts


var translationObject = {
  min: {
    he: "יש להזין לפחות",
    en: "Please enter at least"
  },
  max: {
    he: "יש להזין עד",
    en: "Please enter at most"
  },
  required: {
    he: "נדרש",
    en: "Required"
  },
  email: {
    he: "כתובת דואר אלקטרוני לא תקינה",
    en: "Invalid email address"
  },
  phone: {
    he: "מספר טלפון לא תקין",
    en: "Invalid phone number"
  },
  letters: {
    he: "יש להזין אותיות בלבד",
    en: "Only letters are allowed"
  }
};
var createSchemaContactUs = function createSchemaContactUs(language) {
  var schemaContactUs = es/* object */.Ry({
    first_name: es/* string */.Z_().matches(regex.singleName, translationObject["letters"][language]).min(2, "".concat(translationObject["min"][language], " 2")).max(40, "".concat(translationObject["max"][language], " 40")).required(translationObject["required"][language]),
    last_name: es/* string */.Z_().matches(regex.singleName, translationObject["letters"][language]).min(2, "".concat(translationObject["min"][language], " 2")).max(80, "".concat(translationObject["max"][language], " 80")).required(translationObject["required"][language]),
    email: es/* string */.Z_().email(translationObject["email"][language]).max(80, "".concat(translationObject["max"][language], " 80")).required(translationObject["required"][language]),
    mobile: es/* string */.Z_().matches(regex.phoneNumber, translationObject["phone"][language]).length(10, translationObject["phone"][language]).required(translationObject["required"][language]).max(10, "".concat(translationObject["max"][language], " 10")),
    company: es/* string */.Z_().max(40, "".concat(translationObject["max"][language], " 40")),
    "00N8d0000042MfL": es/* string */.Z_().max(200, "".concat(translationObject["max"][language], " 200")),
    "00N8d000008RbDs": es/* boolean */.O7()
  }).defined();
  return schemaContactUs;
};
;// CONCATENATED MODULE: ./components/contact-us/ContactForm.tsx
























var ORIGIN = "https://www.amot.co.il";
var ContactForm_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactForm__StyledContainer",
  componentId: "sc-1867y5w-0"
})(["max-width:600px;width:100%;display:flex;flex-direction:column;"]);
var StyledFormikInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactForm__StyledFormikInputWrapper",
  componentId: "sc-1867y5w-1"
})(["display:flex;flex-wrap:nowrap;justify-content:space-between;", " textarea{&:focus-visible{border:none;}}"], function (p) {
  return p.$isDesktop === "true" ? "gap: 35px;" : "flex-direction: column;";
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ContactForm__StyledButton",
  componentId: "sc-1867y5w-2"
})(["border:1.5px solid ", ";font-size:13px;font-weight:normal;border-radius:5px;", ""], function (p) {
  return p.theme.colors.black;
}, function (p) {
  return p.$isDesktop === "true" ? "width: 200px;" : "width:100%;";
});
var StyledPrivacyLink = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
  displayName: "ContactForm__StyledPrivacyLink",
  componentId: "sc-1867y5w-3"
})(["text-decoration:underline;font-size:12px;line-height:inherit;"]);
var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
  displayName: "ContactForm__StyledSelect",
  componentId: "sc-1867y5w-4"
})(["width:50%;margin-bottom:20px;.MuiSelect-select{padding-bottom:10px;padding-top:25px;}svg{top:calc(50% - 4px);}"]);
var StyledMuiCheckbox = (0,styled_components_browser_esm/* default */.ZP)(formik_MuiCheckbox).withConfig({
  displayName: "ContactForm__StyledMuiCheckbox",
  componentId: "sc-1867y5w-5"
})([".MuiTouchRipple-child{background-color:", ";}input:focus + svg{border:2px solid blue;}"], colors/* default.gray */.Z.gray);

var ContactForm = function ContactForm() {
  var _useState = (0,react.useState)(""),
      withCompany = _useState[0],
      setWithCompany = _useState[1];

  var _useState2 = (0,react.useState)("false"),
      isAmot360 = _useState2[0],
      setIsAmot360 = _useState2[1];

  var _useState3 = (0,react.useState)("true"),
      isDesktop = _useState3[0],
      setIsDesktop = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      pageName = _useState4[0],
      setPageName = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      categories = _useState5[0],
      setCategories = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      selectedFormName = _useState6[0],
      setSelectedFormName = _useState6[1];

  var _useState7 = (0,react.useState)("false"),
      isAmotConstruction = _useState7[0],
      setIsAmotConstruction = _useState7[1];

  var t = (0,next_intl_cjs_production_min.useTranslations)("contactForm");
  var t360 = (0,next_intl_cjs_production_min.useTranslations)("amot360");

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var formEl = (0,react.useRef)(null);
  var firstNameRef = (0,react.useRef)(null);
  var lastNameRef = (0,react.useRef)(null);
  var emailRef = (0,react.useRef)(null);
  var phoneRef = (0,react.useRef)(null);

  var doHtmlFormPost = function doHtmlFormPost() {
    formEl.current.submit();
  };

  var validationSchemaTranslate = createSchemaContactUs(locale);

  var _useRouter2 = (0,router.useRouter)(),
      query = _useRouter2.query;

  react.useEffect(function () {
    if (query !== null && query !== void 0 && query.isAmot360) {
      fetchCategories();
    }

    setIsAmot360((query === null || query === void 0 ? void 0 : query.isAmot360) || "");
    setWithCompany((query === null || query === void 0 ? void 0 : query.withCompany) || "");
    setPageName((query === null || query === void 0 ? void 0 : query.pageName) || "");
    setIsDesktop((query === null || query === void 0 ? void 0 : query.isDesktop) || "true");
    setSelectedFormName((query === null || query === void 0 ? void 0 : query.selectedFormName) === "undefined" || !(query !== null && query !== void 0 && query.selectedFormName) ? "" : query === null || query === void 0 ? void 0 : query.selectedFormName);
    setIsAmotConstruction((query === null || query === void 0 ? void 0 : query.isAmotConstruction) || ""); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  var escFunction = (0,react.useCallback)(function (event) {
    if (event.key === "Escape") {
      //Do whatever when esc is pressed
      window.parent.postMessage("closePopup", "*");
    }
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener("keydown", escFunction, false);
    return function () {
      window.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  var fetchCategories = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var siteId, _yield$getAmot, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              siteId = (0,SiteId/* getSiteIdByLocale */.j0)(locale);
              _context.next = 3;
              return (0,api.getAmot360)(siteId);

            case 3:
              _yield$getAmot = _context.sent;
              data = _yield$getAmot.data;
              setCategories(data.categories);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCategories() {
      return _ref.apply(this, arguments);
    };
  }();

  var MyForm = (0,formik_esm/* withFormik */.j0)({
    enableReinitialize: true,
    handleSubmit: doHtmlFormPost,
    mapPropsToValues: function mapPropsToValues() {
      var _query$pageName;

      return {
        oid: "00D8d000001FN3O",
        retURL: "https://hauser-marketing.com/amot-sweethome/",
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        company: "",
        selectedFormName: selectedFormName || "",
        // howCanWeHelp: "",
        "00N8d0000042MfL": "",
        // checkbox:
        "00N8d000008RbDs": query !== null && query !== void 0 && (_query$pageName = query.pageName) !== null && _query$pageName !== void 0 && _query$pageName.includes("contact") ? false : true,
        lead_source: "אתר אמות",
        "00N8d0000045E12": pageName,
        "00N8d00000HQgwx": "",
        remarks: ""
      };
    },
    validationSchema: validationSchemaTranslate
  })(function (props) {
    var values = props.values,
        handleSubmit = props.handleSubmit,
        touched = props.touched,
        errors = props.errors,
        handleChange = props.handleChange,
        setFieldTouched = props.setFieldTouched;

    var onChange = function onChange(event, name) {
      event.persist();
      handleChange(event);
      setFieldTouched(name, true, false);
    };

    var getFieldRef = function getFieldRef(field) {
      if (field === "first_name") return firstNameRef;
      if (field === "last_name") return lastNameRef;
      if (field === "email") return emailRef;
      if (field === "mobile") return phoneRef;
      return null;
    };

    var focusOnFirstError = function focusOnFirstError() {
      var errorKeys = Object.keys(props.errors);
      if (errorKeys.length === 0 && props.dirty) return;
      var errorFieldRef = getFieldRef(errorKeys[0] || "first_name");
      setTimeout(function () {
        errorFieldRef === null || errorFieldRef === void 0 ? void 0 : errorFieldRef.current.childNodes[1].firstChild.blur();
        errorFieldRef === null || errorFieldRef === void 0 ? void 0 : errorFieldRef.current.childNodes[1].firstChild.focus();
      }, 300);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm_StyledContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          action: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
          method: "POST",
          ref: formEl,
          onSubmit: handleSubmit,
          noValidate: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFormikInputWrapper, {
            $isDesktop: isDesktop,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "hidden",
              name: "oid",
              value: "00D8d000001FN3O"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "hidden",
              name: "retURL",
              value: "".concat(ORIGIN, "/redirect.html") // value="https://hauser-marketing.com/amot-sweethome/"

            }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              variant: "standard",
              name: "first_name",
              label: t("firstName"),
              autoComplete: "given-name",
              required: true,
              error: touched.first_name && Boolean(errors.first_name),
              helperText: touched.first_name && errors.first_name ? errors.first_name : " ",
              value: values.first_name,
              onChange: onChange,
              InputLabelProps: {
                shrink: true
              },
              inputRef: firstNameRef
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              variant: "standard",
              name: "last_name",
              label: t("lastName"),
              required: true,
              autoComplete: "family-name",
              error: touched.last_name && Boolean(errors.last_name),
              helperText: touched.last_name && errors.last_name ? errors.last_name : " ",
              onChange: onChange,
              InputLabelProps: {
                shrink: true
              },
              inputRef: lastNameRef
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFormikInputWrapper, {
            $isDesktop: isDesktop,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              variant: "standard",
              name: "email",
              label: t("email"),
              required: true,
              autoComplete: "email",
              error: touched.email && Boolean(errors.email),
              onChange: onChange,
              helperText: touched.email && errors.email ? errors.email : " ",
              InputLabelProps: {
                shrink: true
              },
              inputRef: emailRef
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              variant: "standard",
              name: "mobile",
              label: t("phoneNumber"),
              required: true,
              autoComplete: "tel-national",
              error: touched.mobile && Boolean(errors.mobile),
              helperText: touched.mobile && errors.mobile ? errors.mobile : " ",
              inputRef: phoneRef,
              onChange: onChange,
              InputLabelProps: {
                shrink: true
              }
            })]
          }), (withCompany === "true" || isAmot360 === "true") && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormikInputWrapper, {
            $isDesktop: isDesktop,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              variant: "standard",
              name: "company",
              label: t("companyName"),
              autoComplete: "organization",
              error: touched.company && Boolean(errors.company),
              helperText: touched.company ? errors.company : " ",
              onChange: onChange,
              InputLabelProps: {
                shrink: true
              }
            })
          }), isAmot360 === "true" && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormikInputWrapper, {
            $isDesktop: isDesktop,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              id: "00N8d0000042MfL",
              variant: "standard",
              name: "00N8d0000042MfL",
              label: t360("remarks"),
              autoComplete: "remarks",
              error: touched.remarks && Boolean(errors.remarks),
              helperText: touched.remarks ? errors.remarks : " ",
              onChange: onChange,
              multiline: true,
              InputLabelProps: {
                shrink: true
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFormikInputWrapper, {
            $isDesktop: isDesktop,
            children: [isAmot360 != "true" && /*#__PURE__*/(0,jsx_runtime.jsx)(formik_MuiInput, {
              variant: "standard",
              name: "00N8d0000042MfL",
              label: t("howCanWeHelp"),
              error: touched["00N8d0000042Mf"] && Boolean(errors["00N8d0000042Mf"]),
              helperText: touched["00N8d0000042Mf"] && errors["00N8d0000042Mf"] ? errors["00N8d0000042Mf"] : " ",
              multiline: true,
              onChange: onChange,
              InputLabelProps: {
                shrink: true
              }
            }), isAmot360 === "true" && /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                id: "select-amot360-category-label",
                children: t360("chooseCategory")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSelect, {
                name: "selectedFormName",
                labelId: "select-amot360-category-label",
                id: "select-amot360-category",
                label: "choose category",
                onChange: onChange,
                value: values.selectedFormName,
                children: categories === null || categories === void 0 ? void 0 : categories.map(function (category, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: category.formItemName.value,
                    children: category.name.value
                  }, i);
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMuiCheckbox, {
            checked: values["00N8d000008RbDs"],
            label: t("mailingConf"),
            name: "00N8d000008RbDs",
            onChange: onChange,
            error: touched["00N8d000008RbDs"] && Boolean(errors["00N8d000008RbDs"]),
            value: "1",
            helperText: touched["00N8d000008RbDs"] && errors["00N8d000008RbDs"] ? errors["00N8d000008RbDs"] : " ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
              href: mainRoutes/* MainRoutes.general.privacyPolicy */.D.general.privacyPolicy,
              openInNewTab: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPrivacyLink, {
                variant: "body2",
                children: t("privacyPolice")
              })
            })
          }), isAmot360 != "true" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              id: "00N8d0000045ECg",
              type: "hidden",
              name: "00N8d0000045ECg",
              value: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              id: "00N8d0000045E12",
              name: "00N8d0000045E12",
              type: "hidden",
              value: pageName
            })]
          }), isAmot360 === "true" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              id: "00N8d00000HQgwx",
              type: "hidden",
              name: "00N8d00000HQgwx",
              value: "Services"
            }), values.selectedFormName && /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              id: values.selectedFormName,
              type: "hidden",
              name: values.selectedFormName,
              value: values.selectedFormName ? "1" : "0"
            })]
          }), isAmotConstruction === "true" && /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "00N8d00000VBI03",
            name: "00N8d00000VBI03",
            type: "hidden",
            value: "Amot construction"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "lead_source",
            name: "lead_source",
            type: "hidden",
            value: "Amot Website"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
            variant: "outlined",
            type: "submit",
            $isDesktop: isDesktop,
            id: isAmot360 ? "amot360-submit-button" : "amot-submit-button",
            onClick: focusOnFirstError,
            children: t("sendButton")
          })]
        })
      })
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MyForm, {});
};

/* harmony default export */ var contact_us_ContactForm = (ContactForm);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/contact-us-form.tsx






var ContactUsForm = function ContactUsForm() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        httpEquiv: "Content-type",
        content: "text/html; charset=UTF-8"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact_us_ContactForm, {})]
  });
};

var __N_SSG = true;
/* harmony default export */ var contact_us_form = (ContactUsForm);

/***/ }),

/***/ 12464:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us-form",
      function () {
        return __webpack_require__(70837);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3722,6143,9774,2888,179], function() { return __webpack_exec__(12464); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);